import {registerMessageCommon} from 'epic-react-common/src/components/MessageCommon';
import LocalizationStore from '../../stores/LocalizationStore';

export default registerMessageCommon(LocalizationStore);
